import { render } from "./weddinganniversaryReport.vue?vue&type=template&id=2a6edbb4&scoped=true"
import script from "./weddinganniversaryReport.vue?vue&type=script&lang=js"
export * from "./weddinganniversaryReport.vue?vue&type=script&lang=js"

import "./weddinganniversaryReport.vue?vue&type=style&index=0&id=2a6edbb4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6edbb4"]])

export default __exports__